// stores/task.js
import { defineStore } from 'pinia';
import { get_task_list_all } from "@/api/index";

export const useTaskStore = defineStore('task', {
  state: () => ({

    help_doc_info: "",//帮助文档信息

    template_config: {},

    task_info: {
      project_info: {}
    },

    start_node_name: "",//启动节点名称
    current_task_name: "", //当前任务名称

    filter_data_file: "",//筛选数据文件路径
    metadata_file: "",//分组数据文件路径
    group_plan_file: "",//分组方案文件路径

    group_data: {
      // "index": [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
      // "columns": ["companyCode", "sampleCode", "sampleName", "group", "color"],
      // "data": [
      //   ["QC_01", "QC_01", "QC_01", "QC", "#1f77b4"],
      //   ["QC_02", "QC_02", "QC_02", "QC", "#1f77b4"],
      //   ["QC_03", "QC_03", "QC_03", "QC", "#1f77b4"],
      //   ["yk250801001", "CHSGSbefore1", "CHSGSbefore1", "CHSGSbefore", "#8c564b"],
      //   ["yk250801002", "CHSGSbefore2", "CHSGSbefore2", "CHSGSbefore", "#8c564b"],
      //   ["yk250801003", "CHSGSbefore3", "CHSGSbefore3", "CHSGSbefore", "#8c564b"],
      //   ["yk250801004", "CHSGSbefore4", "CHSGSbefore4", "CHSGSbefore", "#8c564b"],
      //   ["yk250801005", "CHSGSafter1", "CHSGSafter1", "CHSGSafter", "#9edae5"],
      //   ["yk250801006", "CHSGSafter2", "CHSGSafter2", "CHSGSafter", "#9edae5"],
      //   ["yk250801007", "CHSGSafter3", "CHSGSafter3", "CHSGSafter", "#9edae5"],
      //   ["yk250801008", "CHSGSafter4", "CHSGSafter4", "CHSGSafter", "#9edae5"]
      // ]
    },
    plan_data: {
      // "index": [0],
      // "columns": ["comparison", "label", "Method"],
      // "data": [
      //   ["CHSGSafter_vs_CHSGSbefore", "CHSGSafter_vs_CHSGSbefore", "t.test"],
      //   ["CHSGSafter_vs_CHSGSbefore", "CHSGSafter_vs_CHSGSbefore", "t.test"],
      //   ["CHSGSafter_vs_CHSGSbefore", "CHSGSafter_vs_CHSGSbefore", "t.test"],
      // ]

      columns: [],
      data: []
    },

    all_task_data: {},



    //是否重分析
    is_reanalysis: false,

    _lastFetchTime: 0,
  }),
  actions: {
    setTaskInfo(data) {
      this.task_info = data   // 只负责更新
    },
    setGroupData(data) {
      console.log("仓库更新分组数据", data);
      this.group_data = data
    },
    setPlanData(data) {
      this.plan_data = data
    },
    setAllTaskData(data) {
      this.all_task_data = data
    },
    setIsReanalysis(data) {
      this.is_reanalysis = data
    },


    /**
     * 获取任务列表（带节流，30s 内不会重复请求）
     * @param {string} task_id 
     * @param {boolean} force 是否强制刷新（跳过节流）
     */
    async fetchTaskListAll(task_id, force = false) {
      if (!task_id) return

      const now = Date.now()
      if (!force && now - this._lastFetchTime < 30 * 1000 && Object.keys(this.all_task_data).length) {
        // 30s 内没有刷新过，且有缓存，直接返回已有数据
        return this.all_task_data
      }
      try {
        const result = await get_task_list_all({ task_id })
        if (result.data) {
          this.setAllTaskData(result.data)
          this._lastFetchTime = now
        }
        return this.all_task_data
      } catch (err) {
        console.error('获取任务列表失败', err)
        throw err
      }
    },

  }
});



export const useFormStore = defineStore('form', {
  state: () => ({
    process_forms: [],

    all_process_forms: [],
  }),
  actions: {
    setProcessForms(data) {
      this.process_forms = data;
    },
    setAllProcessForms(data) {
      this.all_process_forms = data;
    }
  }
});
